module.exports = __webpack_public_path__ + "img/vid.d44e937f.svg";